import { render, staticRenderFns } from "./ViewInfo.vue?vue&type=template&id=6c54fea8&scoped=true"
import script from "./ViewInfo.vue?vue&type=script&lang=js"
export * from "./ViewInfo.vue?vue&type=script&lang=js"
import style0 from "./ViewInfo.vue?vue&type=style&index=0&id=6c54fea8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c54fea8",
  null
  
)

export default component.exports